/**
 * Registry of in-memory cache clearers.
 *
 * Each data service keeps a module-level Map cache. Logout wipes storage, but a
 * Map lives until the page reloads — and logout does not reload the page — so
 * the next person to log in on the same tab could be served the previous user's
 * lists for the rest of the TTL (policy C16). Services register their
 * `clearCache` here; `clearSessionCaches()` runs them all. Kept in its own
 * module so the auth service never has to import the data services (import
 * cycle).
 */
const clearers = new Set();

export function registerClearable(fn) {
  if (typeof fn === 'function') clearers.add(fn);
}

export function clearRegisteredCaches() {
  clearers.forEach((fn) => {
    try { fn(); } catch (e) { /* one bad clearer must not stop the rest */ }
  });
}
